import { ENV } from '@/env';

declare global {
  interface Window {
    pendo: any;
  }
}

type PendoVisitor = {
  id: string;
  name: string;
  email: string;
};

export type PendoConfig = {
  visitor: PendoVisitor;
  account?: unknown;
};

let loaded = false;

export function initializePendo(visitor: PendoConfig['visitor'], account?: PendoConfig['account']) {
  if (!window.pendo || ENV !== 'production' || loaded) {
    return;
  }

  window.pendo.initialize({ account, visitor });
  loaded = true;
}
